module.exports = __webpack_public_path__ + "static/agatawork6-f9f568e85316e4e79e0e42f35946641c.jpg";